<template>
    <div class="more-news">
        <div class="title">
            更多新闻
        </div>

        <div class="cont">
            <a 
            class="cont-c" 
            v-for="(item,index) in data" 
            :key="index"
            target="_blank"
            :href="`/news/${item.guid}`"
            >
                {{item.title}}
            </a>
        </div>

    </div>
</template>

<script>
export default {
    props:{
        data:{
            type: Array,
            default: () => [],
        },
    },
    name: '',
    data() {
        return {
            table: [],
        };
    },
    mounted() {},
    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
.more-news {
    padding: 20px;
    .title {
        font-size: 16px;
        height: 40px;
        line-height: 40px;
        font-weight: bold;
    }
    .cont {
        .cont-c {
            display: block;
            font-size: 14px;
            height: 60px;
            line-height: 60px;
            font-weight: bold;
            border-bottom: 1px solid #eaeaea;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            color: #383838;

            &:hover{
                cursor: pointer;
                color: #5588ff;
            }
        }

        .cont-c:nth-last-child(1){
            border-bottom: none;
        }
    }
}
</style>
